import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { Business } from '../business/business.entity';
import { Site } from '../site/site.entity';
import { PublicUser, User } from '../user/user.entity';

export type PublicdataImport = Pick<
	DataImport,
	'id' | 'assetPath' | 'type' | 'title' | 'mimeType' | 'status' | 'user' | 'uploadedBy' | 'created' | 'details'
> & {
	// Other Public Properties
};

export enum Type {
	BusinessVerificationList = 'business-verification-list',
	Users = "users"
}

export enum Status {
	Pending = 'pending',
	Success = 'success',
	Failed = 'failed'
}

export enum Provider {
	Amazon = 'amazon',
	Cloudinary = 'cloudinary',
	User = "user"
}

@Entity('dataImports')
export class DataImport {
	constructor(value?: Partial<DataImport>) {
		if (value) {
			value = JSON.parse(JSON.stringify(value));
		}
		for (const k in value) {
			this[k] = value[k];
		}
	}

	@PrimaryGeneratedColumn('uuid')
	id: string;

	@Column({
		type: 'enum',
		enum: Type,
		nullable: false
	})
	public type: Type;

	@Column({
		type: 'enum',
		enum: Status,
		default: Status.Pending,
		nullable: true
	})
	public status: Status;

	@Column('text', { nullable: false })
	public title: string;

	@Column('text', { nullable: false })
	public assetPath: string;

	@Column('text', { nullable: true })
	public mimeType: string;

	@Column('timestamptz', { default: () => 'NOW()' })
	public created: string;

	@Column("text", {nullable: true})
	public details: string;

	@Column('uuid', { nullable: true })
	public businessId?: string;
	@ManyToOne(() => Business, {
		eager: false,
		nullable: true,
		onDelete: 'CASCADE'
	})
	@JoinColumn({ name: 'businessId' })
	public business?: Business | Partial<Business>;

	@Column('uuid', { nullable: false })
	public siteId: string;
	@ManyToOne(() => Site, {
		eager: false,
		nullable: false,
		onDelete: 'CASCADE'
	})
	@JoinColumn({ name: 'siteId' })
	public site?: Site | Partial<Site>;

	@Column('uuid', { nullable: true })
	public userId?: string;
	@ManyToOne(() => User, {
		eager: false,
		nullable: true,
		onDelete: 'CASCADE'
	})
	@JoinColumn({ name: 'userId' })
	public user?: User | Partial<User>;

	@Column({
		type: 'enum',
		enum: Provider,
		nullable: false
	})
	public provider: Provider;

	public uploadedBy: string;

	public toPublic() {
		const pub: Partial<PublicdataImport> = {
			id: this.id,
			title: this.title,
			type: this.type,
			mimeType: this.mimeType,
			status: this.status,
			created: this.created,
			details: this.details
		};

		if (this.user) {
			pub.uploadedBy = this.user?.settings?.fullName;
		}

		// Other public transformations

		return pub as PublicdataImport;
	}
}
